// ----------------------------------------------------------------------------
// Template: Pages
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import 'sections/header/header';
// import 'sections/announcement-bar/announcement-bar--dismissible';
import 'sections/main-page/main-page';
import 'sections/intro-block/intro-block';
import 'sections/content-panel/content-panel';
import 'sections/icon-block/icon-block';
import 'sections/banner/banner-block';
import 'sections/collection-promo/collection-promo';
import 'sections/faqs/faqs';
import 'sections/collection-list/collection-list';
import 'sections/app-wrapper/app-wrapper';
import 'sections/content-cards/content-cards';
import 'sections/todays-deal/todays-deal';
import 'sections/featured-collection/featured-collection';
import 'sections/author-archive/author-archive';
import 'sections/blog-posts/blog-posts';
import 'sections/newsletter/newsletter';
import 'sections/page-hero/page-hero';
import 'sections/rich-text/rich-text';
import 'sections/video-banner/video-block';
import 'sections/featured-brands/featured-brands';
import 'sections/footer/footer';
import 'sections/guarantee-bar/guarantee-bar';
import 'sections/predictive-search/predictive-search';
import 'sections/product-details/product-details';